import { render, staticRenderFns } from "./ActividadParrafo.vue?vue&type=template&id=0d31ef97&scoped=true"
import script from "./ActividadParrafo.vue?vue&type=script&lang=js"
export * from "./ActividadParrafo.vue?vue&type=script&lang=js"
import style0 from "./ActividadParrafo.vue?vue&type=style&index=0&id=0d31ef97&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d31ef97",
  null
  
)

export default component.exports